import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BannerImages } from '../header/header.model';
import { getImagesUrl } from '../../../../constants/url-constants';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  constructor(private httpClient: HttpClient) {}

  getAllImages() {
    return this.httpClient.get<BannerImages[]>(getImagesUrl);
  }
}
